
































import Vue from 'vue';
import _ from 'lodash';
import Pusher from 'pusher-js';
import { Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Build } from '@/types/build';
import BuildTimeLine from './BuildTimeLine.vue';
import BuildListTile from './BuildListTile.vue';
import BuildMainSiteTimeLine from './BuildMainSiteTimeLine.vue';
import BuildPartnerSitesTimeLine from './BuildPartnerSitesTimeLine.vue';

@Component({
  components: {
    BuildTimeLine,
    BuildListTile,
    BuildMainSiteTimeLine,
    BuildPartnerSitesTimeLine,
  },
})
export default class CurrentBuild extends Vue {
  @Mutation('builds/newLiveBuild') newLiveBuild!: Function;
  @Mutation('builds/updateShowSummaryPanel') updateShowSummaryPanel!: Function;
  @Mutation('builds/updateShowMainPanel') updateShowMainPanel!: Function;
  @Mutation('builds/updateShowPartnerPanel') updateShowPartnerPanel!: Function;
  @Getter('builds/live') build!: Build;
  @Getter('builds/builds') builds!: Build[];
  @Getter('builds/queueFail') queueFail!: boolean;
  @Action('builds/saveLiveBuild') saveLiveBuild!: Function;
  @Action('builds/saveBuild') saveBuild!: Function;

  buildInProgress: boolean = false;

  created() {
    let pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: 'eu',
      encrypted: true,
    });

    let channel = pusher.subscribe('build');

    channel.bind('App\\Events\\Build\\BuildUpdated', data => {
      this.buildInProgress = data.build.in_progress === 1;
      this.updateShowSummaryPanel(data.build.build_menus);

      let showMainPanel =
        data.build.invalidate_cdn === 1 && data.build.complete === 1 ? 1 : 0;
      this.updateShowMainPanel(showMainPanel);

      this.updateShowPartnerPanel(data.build.completed_all_steps);

      this.saveLiveBuild(data.build);
    });
  }

  get failedBuilds(): Build[] {
    return _.filter(this.builds, build => build.in_progress === 1);
  }

  startBuild() {
    this.newLiveBuild();
    this.buildInProgress = true;
    this.saveBuild(this.build);
  }
}
